import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import ET3Div from "../../../../../core/et3-div";
import UserActionButtons from "./user-action-buttons";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import UserChangeUserName from "./user-change-username";
import UserChangeUserStatus from "./user-change-status";
import UserOptionsBox from "./user-options-box";
import getCorePersonalStore from "../../../../../stores/core/core-personal-store";
import KhattabActions from "./KhattabaActions";

const ModifyUserData = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userStatusDeleted = getUserAdvancedStore().userStatusDeleted.get();
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();

  return isAnyKhattabaAdmin ? (
    <KhattabActions />
  ) : !userStatusDeleted ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={1400}
      height={350}
      fDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1400}
        height={350}
        fDirection="row"
        alignItems="center"
        justifyContent="space-between"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <UserChangeUserName />
        <UserChangeUserStatus />
        <UserActionButtons />
        <UserOptionsBox />
      </ET3Div>
    </ET3Div>
  ) : null;
});
export default ModifyUserData;
